
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Crown, LogIn, Baby, Candy, ToyBrick, Gift, Star } from "lucide-react";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";
import { Tabs } from "@/components/ui/tabs";
import { GalleryTabs } from "./GalleryTabs";
import { PregnancyPhotoCollection } from "./PregnancyPhotoCollection";

export function GuestGallery() {
  const { language } = useLanguage();
  
  return (
    <main className="min-h-screen pt-24 pb-16 bg-gradient-to-b from-blue-50 to-pink-50">
      <div className="container max-w-4xl mx-auto px-4">
        <div className="flex flex-col items-center justify-center py-8 text-center">
          <div className="mb-4">
            <div className="bg-pink-100 p-3 rounded-full inline-block">
              <Baby className="h-10 w-10 text-pink-500" />
            </div>
          </div>
          <h1 className="text-3xl font-bold tracking-tight mb-4 text-blue-600">
            {t('gallery.title', language)}
          </h1>
          <p className="text-muted-foreground mb-6">
            {language === 'ja' 
              ? 'サインインして、赤ちゃんの成長を写真で記録しましょう。'
              : language === 'es'
              ? 'Inicia sesión para registrar el crecimiento de tu bebé con fotos.'
              : 'Sign in to record your baby\'s growth with photos.'}
          </p>
          <div className="flex gap-4 justify-center mb-8">
            <Link to="/login">
              <Button variant="outline" className="flex items-center gap-1 bg-purple-50 border-purple-200 hover:bg-purple-100">
                <LogIn className="h-4 w-4" />
                {t('common.login', language)}
              </Button>
            </Link>
            <Link to="/premium">
              <Button className="flex items-center gap-1 bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600">
                <Crown className="h-4 w-4" />
                {t('index.premiumBenefits.upgradeToPremium', language)}
              </Button>
            </Link>
          </div>
          
          {/* Decorative toys */}
          <div className="flex justify-center gap-8 mb-10">
            <div className="animate-bounce delay-100">
              <ToyBrick className="h-10 w-10 text-red-400" />
            </div>
            <div className="animate-bounce delay-300">
              <Candy className="h-10 w-10 text-pink-400" />
            </div>
            <div className="animate-bounce delay-500">
              <Gift className="h-10 w-10 text-blue-400" />
            </div>
            <div className="animate-bounce delay-700">
              <Star className="h-10 w-10 text-yellow-400" />
            </div>
          </div>
        </div>
        
        {/* Display gallery demo with sample photos for guest users */}
        <div className="mb-8 bg-white p-6 rounded-xl shadow-md border-2 border-blue-100">
          <h2 className="text-2xl font-semibold mb-4 text-pink-600">{t('gallery.guestDemo', language) || 'Gallery Preview'}</h2>
          <div className="mb-4 text-muted-foreground">
            <p>{t('gallery.sampleDescription', language) || 'Browse our sample gallery to see what you can create with a premium account. Upload and organize your own photos when you sign up!'}</p>
          </div>
          <GalleryTabs
            isPremium={false}
            isGuestMode={true}
            recentPhotos={[]}
            milestonePhotos={[]}
            collectionPhotos={{}}
            fetchGalleryPhotos={() => {}}
          />
        </div>
        
        {/* Sample pregnancy collection */}
        <PregnancyPhotoCollection isGuestMode={true} />

        {/* Floating bubbles decoration */}
        <div className="relative h-40 mt-10">
          <div className="absolute bottom-0 left-1/4 w-16 h-16 bg-blue-100 rounded-full animate-bounce delay-300 opacity-70"></div>
          <div className="absolute bottom-10 left-1/2 w-12 h-12 bg-pink-100 rounded-full animate-bounce delay-500 opacity-70"></div>
          <div className="absolute bottom-5 left-3/4 w-14 h-14 bg-yellow-100 rounded-full animate-bounce delay-700 opacity-70"></div>
        </div>
      </div>
    </main>
  );
}
